import styled from 'styled-components';

export const Container = styled.div`
  font-family: ${(props) => props.theme.fonts.body}; /* Use the font from theme */
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  text-align: center;
`;
